/**
 * Doit s'exécuter en premier dans le bundle web.
 * React 18+ a supprimé createFactory ; react-google-maps (react-native-web-maps) en a encore besoin.
 */
const React = require("react");
if (typeof window !== "undefined") {
	window.React = React;
}
if (typeof React.createFactory === "undefined") {
	React.createFactory = function (type) {
		return function (props, ...children) {
			return React.createElement(type, props, ...children);
		};
	};
}
